"use client";

import { useEffect, useState } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useAuth } from "@/lib/auth-context";
import { apiGetQuiet } from "@/lib/api";

function NavLink({ href, label, badge, prefixMatch }: { href: string; label: string; badge?: boolean; prefixMatch?: boolean }) {
  const pathname = usePathname();
  const active = prefixMatch ? pathname.startsWith(href) : pathname === href;
  return (
    <Link
      href={href}
      className={`transition-colors no-underline ${
        active
          ? "text-white [text-shadow:0_0_8px_#fff,0_0_16px_#fff,0_0_30px_var(--color-accent),0_0_50px_var(--color-accent)]"
          : "text-muted hover:text-accent"
      }`}
    >
      {badge && <span className="text-amber mr-0.5">•</span>}
      {label}
    </Link>
  );
}

export default function NavLinks() {
  const { user } = useAuth();
  const [isSudo, setIsSudo] = useState(false);

  useEffect(() => {
    if (!user) return;
    apiGetQuiet<{ allowed: boolean }>("/terminal/access")
      .then((r) => setIsSudo(r.allowed))
      .catch(() => {});
  }, [user]);

  if (!user) return null;

  return (
    <div className="flex items-center gap-4 text-sm">
      <NavLink href="/photos" label="Documents" prefixMatch />
      <NavLink href="/sample" label="Sample" />
      {isSudo && <NavLink href="/admin" label="Admin" />}
      {user.role === "admin" && <NavLink href="/users" label="Users" />}
    </div>
  );
}
